/**
 * js/utils/pathUtils.js
 * Módulo para resolver e validar caminhos de imagem.
 */

// Uma imagem de placeholder padrão para ser usada quando a imagem principal falhar.
const DEFAULT_PLACEHOLDER = '/assets/ui/rewards/avatar.png';

/**
 * Garante que um caminho de imagem seja utilizável, seja ele uma URL completa
 * da Supabase ou um caminho local.
 * @param {string | null | undefined} path - O caminho da imagem vindo do banco de dados ou de um arquivo de dados.
 * @param {string} [placeholder=DEFAULT_PLACEHOLDER] - Uma imagem de fallback opcional.
 * @returns {string} Uma URL de imagem válida e segura.
 */
export function resolveImagePath(path, placeholder = DEFAULT_PLACEHOLDER) {
  // 1. Se o caminho for nulo, indefinido ou vazio, retorna o placeholder.
  if (!path) {
    return placeholder;
  }

  // 2. Se o caminho já é uma URL completa, ele está correto. Retorne-o.
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // 3. Se o caminho NÃO começa com '/', ele é relativo e precisa ser corrigido.
  // Isso transforma "assets/images/..." em "/assets/images/...".
  if (!path.startsWith('/')) {
    return '/' + path;
  }

  // 4. Se chegou até aqui, o caminho já é um caminho absoluto local correto (ex: "/assets/img.png").
  return path;
}